import type { FormInstance, FormItemProps, FormProps } from 'antd'
import { Form } from 'antd'
import type { ReactNode } from 'react'

export type UiFormProps<Values = Record<string, unknown>> = Omit<FormProps<Values>, 'children'> & {
  form?: FormInstance<Values>
  children?: ReactNode
}

export function UiForm<Values extends object = Record<string, unknown>>(
  props: UiFormProps<Values>
) {
  const { layout = 'vertical', ...rest } = props

  return <Form<Values> layout={layout} {...rest} />
}

export type UiFormItemProps = FormItemProps

export function UiFormItem(props: UiFormItemProps) {
  return <Form.Item {...props} />
}

// Re-export AntD Form hooks (không phải component render) để features/pages
// không import trực tiếp 'antd' (hard-rule module-authoring #1).
export const useForm = Form.useForm
export const useWatch = Form.useWatch
